import { render, staticRenderFns } from "./AdminExpositorModal.vue?vue&type=template&id=2a8ba44c&scoped=true"
import script from "./AdminExpositorModal.vue?vue&type=script&lang=js"
export * from "./AdminExpositorModal.vue?vue&type=script&lang=js"
import style0 from "./AdminExpositorModal.vue?vue&type=style&index=0&id=2a8ba44c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8ba44c",
  null
  
)

export default component.exports